import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/notes`;

export const listNotes = () => axios.get(API).then((r) => r.data);
export const createNote = (n) => axios.post(API, n).then((r) => r.data);
export const updateNote = (id, n) => axios.put(`${API}/${id}`, n).then((r) => r.data);
export const deleteNote = (id) => axios.delete(`${API}/${id}`);

export const CATEGORIES = [
  ["general", "General"], ["visits", "Visits"], ["qty", "Qty picked"], ["productivity", "Productivity"],
  ["lost_time", "Lost time"], ["absence", "Absence / leave"], ["overtime", "Overtime"], ["breaks", "Breaks"],
  ["headcount", "Headcount"], ["shifts", "Shifts"],
];
export const catLabel = (k) => CATEGORIES.find((c) => c[0] === k)?.[1] || k;

const iso = (d) => d.toISOString().slice(0, 10);
const utc = (s) => new Date(`${s}T00:00:00Z`);

export function periodRange(period, value, endValue) {
  if (period === "day") return { start: value, end: value };
  if (period === "week") {
    const d = utc(value);
    d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7));
    const e = new Date(d); e.setUTCDate(e.getUTCDate() + 6);
    return { start: iso(d), end: iso(e) };
  }
  if (period === "month") {
    const [y, m] = value.split("-").map(Number);
    return { start: `${value.slice(0, 7)}-01`, end: iso(new Date(Date.UTC(y, m, 0))) };
  }
  if (period === "quarter") {
    const [y, q] = value.split("-Q").map(Number);
    return { start: iso(new Date(Date.UTC(y, (q - 1) * 3, 1))), end: iso(new Date(Date.UTC(y, q * 3, 0))) };
  }
  return { start: value, end: endValue || value };
}

const fmt = (s, o) => utc(s).toLocaleDateString("en-GB", { timeZone: "UTC", ...o });

export function periodLabel(n) {
  if (n.period === "day") return fmt(n.start, { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
  if (n.period === "week") return `w/c ${fmt(n.start, { day: "2-digit", month: "short", year: "numeric" })}`;
  if (n.period === "month") return fmt(n.start, { month: "long", year: "numeric" });
  if (n.period === "quarter") return `${n.start.slice(0, 4)} Q${Math.floor((+n.start.slice(5, 7) - 1) / 3) + 1}`;
  return `${fmt(n.start, { day: "2-digit", month: "short", year: "numeric" })} – ${fmt(n.end, { day: "2-digit", month: "short", year: "numeric" })}`;
}

export const overlaps = (n, start, end) => n.start <= end && n.end >= start;
export const monthBounds = (m) => periodRange("month", m);
